export default __webpack_public_path__ + "static/media/sedgewick.d0d47fe1.jpg";